import { Signal } from "signals";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";

export default class GambleComponent {
    public static readonly DEFAULT: string = "default";
    public static readonly GAMBLE: string = "gamble";

    public onGambleStart: Signal = new Signal();
    public onGambleCollect: Signal = new Signal();

    private SmartUIGroups: HeadlessSmartUIGroup[] = [];
    private gambleBtn: FlexiButton;
    private collectBtn: FlexiButton;

    constructor() {
        if (Layers.GambleControls.hasScene(GambleComponent.DEFAULT)) {
            const group = SmartUIManager.newSmartUIGroup(Layers.GambleControls, GambleComponent.DEFAULT, "gamble");
            group.addEnableCondition([SmartUIFlag.GAMBLE]);
            group.addDisableCondition([SmartUIFlag.PROMPT]);
            group.addDisableCondition([SmartUIFlag.AUTO_SPIN]);
            group.addDisableCondition([SmartUIFlag.AWAITING_RESPONSE]);

            this.gambleBtn = Layers.GambleControls.getFlexiButton("gamble_button");
            this.gambleBtn.on(ButtonEvent.CLICK, () => this.start());

            this.collectBtn = Layers.GambleControls.getFlexiButton("gamble_collect");
            this.collectBtn.on(ButtonEvent.CLICK, () => this.collect());

            this.SmartUIGroups.push(group);
        }
    }

    private start(): void {
        this.onGambleStart.dispatch();
    }

    private collect(): void {
        this.onGambleCollect.dispatch();
    }
}
